import type { IconData } from '@stacksjs/iconify-core'

export const commentSquare: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M496 496h-47.229l-69.522-128H40a24.03 24.03 0 0 1-24-24V40a24.03 24.03 0 0 1 24-24h432a24.03 24.03 0 0 1 24 24ZM48 336h350.284L464 456.993V48H48Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default commentSquare
